import useApiMutation from 'shared/hooks/use-api-mutation';
import useInfiniteQueryHelpers from 'shared/hooks/use-infinite-query-helpers';
import useQueryHelpers from 'shared/hooks/use-query-helpers';
import {AdditionalProps} from '../types';
import additionalsKeys from '../util/additionals-keys';
import additionalGroupsKeys from 'modules/additional-groups/util/additional-groups-keys';
import {useNavigate} from 'react-router-dom';

export interface EditAdditionalProps extends Omit<AdditionalProps, 'id'> {}

const useEditAdditional = (id: string) => {
  const {update} = useInfiniteQueryHelpers();
  const {setData, ...queryHelpers} = useQueryHelpers();
  const navigate = useNavigate();

  const onSuccess = (data: AdditionalProps) => {
    update(additionalsKeys.list(), data);
    setData(additionalsKeys.details(id), data);
    queryHelpers.update(
      additionalGroupsKeys.additionals(data.additionalGroupId),
      data,
    );

    return navigate(
      `/menu/additional-groups/${data.additionalGroupId}/additionals`,
    );
  };

  return useApiMutation<EditAdditionalProps>({
    url: `/additionals/${id}`,
    method: 'PATCH',
    errorTitle: 'Erro ao editar adicional',
    successTitle: 'Editar adicional',
    successMessage: 'Adicional atualizado com sucesso',
    onSuccess,
  });
};

export default useEditAdditional;
